import React, { useEffect, useState } from 'react';
import { ButtonSecondary } from '@spotify-internal/encore-web';
import { useT } from 'client/i18n/hooks/useT';

export function SubmitDraftButton(props: {
  isSubmitting: boolean;
  isPublished?: boolean;
  pristine: boolean;
  onClick: (e: React.FormEvent) => void;
}) {
  const { isPublished, pristine, isSubmitting, onClick } = props;
  const [isActive, setIsActive] = useState(false);
  const t = useT();

  function getText() {
    if (isActive && isSubmitting) {
      return isPublished
        ? t('Button.Reverting', 'Reverting...', 'Reverting button text')
        : t('Button.Saving', 'Saving...', 'Saving button text');
    }
    return isPublished
      ? t(
          'Button.RevertToDraft',
          'Revert to draft',
          'Revert to draft button text'
        )
      : t('Button.SaveAsDraft', 'Save as draft', 'Save as draft button text');
  }

  useEffect(() => {
    if (!isSubmitting && !isPublished) {
      setIsActive(false);
    }
  }, [isPublished, isSubmitting]);

  return (
    <ButtonSecondary
      disabled={isSubmitting || (pristine && !isPublished)}
      onClick={e => {
        setIsActive(true);
        onClick(e);
      }}
    >
      {getText()}
    </ButtonSecondary>
  );
}
